<template>
  <BaseSelectSimple
    v-if="metadata && metadata.users"
    :label="label"
    :placeholder="label"
    :name="name"
    :default-value="
      metadata.users && metadata.users.filter((el) => el.id === model[name])
    "
    :options="metadata.users"
    :disabled="permission"
    :errors="errors[name]"
    @set-selected="getInputValue"
  />
</template>
<script>
import BaseSelectSimple from './BaseSelectSimple.vue'

export default {
  name: 'SelectUserSimple',
  components: { BaseSelectSimple },
  props: {
    errors: {},
    getInputValue: {},
    metadata: {},
    permission: {},
    model: {},
    label: {
      type: String,
      required: false,
      default: 'responsable'
    },
    name: {
      type: String,
      required: false,
      default: 'responsable_id'
    }
  }
}
</script>
